import { render, staticRenderFns } from "./OptionItemOwner.vue?vue&type=template&id=87b555f8&"
import script from "./OptionItemOwner.vue?vue&type=script&lang=js&"
export * from "./OptionItemOwner.vue?vue&type=script&lang=js&"
import style0 from "./OptionItemOwner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports